<!-- 発注管理リスト -->
<div class="breadcrumb">
  <p-breadcrumb
    [model]="items"
    styleClass="breadcrumbcss"
    (onItemClick)="itemClicked($event)"
  ></p-breadcrumb>
</div>
